<template>
  <tr>
    <td>{{ orderline.product.name }}</td>
    <td>{{ orderline.quantity }} stk</td>
    <td>kr {{ subtotal }},-</td>
  </tr>
</template>

<script>
export default {
  name: "OrderSummaryItem",
  props: {
    orderline: {
      type: Object,
      required: true,
    },
  },

  computed: {
    subtotal() {
      return this.orderline.product.price * this.orderline.quantity;
    },
  },
};
</script>
